// extracted by mini-css-extract-plugin
export default {"infoIcon":"sign-request-archive-modal_infoIcon__8XwNz"};